var map = {
	"./IMG_8329.JPG": 5297,
	"./IMG_8338.JPG": 7267,
	"./IMG_8343.JPG": 9957,
	"./IMG_8344.JPG": 5150,
	"./IMG_8345.JPG": 1483,
	"./IMG_8346.JPG": 1580,
	"./IMG_8347.JPG": 2105,
	"./IMG_8348.JPG": 3506,
	"./IMG_8358.JPG": 5129,
	"./IMG_8359.JPG": 7116,
	"./IMG_8390.PNG": 2565,
	"./IMG_8927.JPG": 3981,
	"./Premios festival Freirina Live rock.JPG": 1997,
	"./mybeginnings.jpg": 4762,
	"./video-output-198BDABE-1D5F-40DC-A2B8-87C3E0EE299F.mp4": 8695
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7052;
module.exports = webpackAsyncContext;